import PT from 'prop-types';
import { connect } from 'react-redux';

import { Select } from '~/eds/src/components/Select/Select';
import { WorkflowPartyType } from '~/enums/WorkflowPartyType';
import { useIntl } from 'react-intl';
import { getSigners } from '~/reducers/workflow';

function SignerSelect({
  blacklistValues = [],
  value,
  onChange,
  // connected
  signers,
  shouldValidate,
}) {
  const intl = useIntl();
  const options = signers.map((signer) => {
    const { name, partyType } = signer;
    return {
      label: `${name} (${
        partyType === WorkflowPartyType.Counterparty
          ? intl.formatMessage({
              id: 'SignerSelect.counterpartyLabel',
              defaultMessage: 'Counterparty',
              description: 'Label for counterparty signer',
            })
          : intl.formatMessage({
              id: 'SignerSelect.internalLabel',
              defaultMessage: 'Internal',
              description: 'Label for internal signer',
            })
      })`,
      value: signer.id,
    };
  });

  let error;
  if (shouldValidate) {
    if (value == null) {
      error = intl.formatMessage({
        id: 'SignerSelect.missingSigner',
        defaultMessage: 'Missing Signer',
        description: 'Error message when no signer is selected',
      });
    } else if (!options.find((option) => option.value === value)) {
      error = intl.formatMessage({
        id: 'SignerSelect.invalidSigner',
        defaultMessage: 'Invalid Signer',
        description: 'Error message when selected signer is invalid',
      });
    }
  }

  return (
    <Select
      enablePortal
      isClearable={false}
      error={error}
      options={options}
      placeholder={
        error ||
        intl.formatMessage({
          id: 'SignerSelect.placeholder',
          defaultMessage: 'Specify a signer',
          description: 'Placeholder text for signer selection',
        })
      }
      value={value}
      width="input.l.width"
      onChange={onChange}
      filterOption={(option) => {
        return !blacklistValues.includes(option.value);
      }}
      name={intl.formatMessage({
        id: 'SignerSelect.missingSigner',
        defaultMessage: 'Missing Signer',
        description: 'Error message when no signer is selected',
      })}
    />
  );
}

SignerSelect.propTypes = {
  blacklistValues: PT.arrayOf(PT.string.isRequired),
  value: PT.string,
  onChange: PT.func.isRequired,
};

function mapStateToProps({ builder, workflow }) {
  return {
    signers: getSigners(workflow),
    shouldValidate: builder.shouldValidate,
  };
}

export default connect(mapStateToProps)(SignerSelect);
